import { useEffect, useState } from 'react'

// True on phone-sized viewports. Drives the dedicated mobile shell
// (bottom action bar + slide-in drawers) instead of the desktop ribbon
// and docked sidebars. Threshold matches Tailwind's `md` breakpoint so
// tablets keep the full desktop layout.
//
// A segunda condição apanha o telemóvel deitado: 812x375 passa dos 767px
// de largura, caía no layout de desktop e a faixa de ferramentas mais as
// duas barras laterais deixavam o canvas 3D com 134x215px, inutilizável.
// 450px de altura fica acima do telemóvel deitado mais alto (428px) e
// muito abaixo de qualquer tablet deitado (768px) ou janela de desktop
// com que se trabalhe a sério.
const MOBILE_QUERY = '(max-width: 767px), (max-height: 450px)'

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia(MOBILE_QUERY).matches
  })

  useEffect(() => {
    if (!window.matchMedia) return
    const mql = window.matchMedia(MOBILE_QUERY)
    const onChange = () => setIsMobile(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
